// This is temporary until all users are migrated to the new permission entry.
// const getIsSubscriptionOwner = ({subscription} = {}, currentUserId) =>
//   // ((typeof permission === 'object' ? permission.permission : permission) === "owner")
//   // subscription
//   true;

const getIsSubscriptionOwner = () => true;

export default getIsSubscriptionOwner;
